





























































































































import { PropType } from 'vue';
import { mapGetters } from 'vuex';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { InvoiceStateEnum } from '@/models';
import { IInvoiceStateVisual } from '@/store/invoice';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import colorable from '@/mixins/colorable';

export default mixins(auth, colorable).extend({
  components: { ErrorAlert },

  name: 'InvoiceStateCard',
  props: {
    state: Number as PropType<InvoiceStateEnum>,
    loading: Boolean
  },

  computed: {
    ...mapGetters({
      getInvoiceStateVisualByState: 'invoice/getInvoiceStateVisualByState'
    }),

    invoiceState(): IInvoiceStateVisual {
      return this.getInvoiceStateVisualByState(this.state);
    },

    canCancel(): boolean {
      return (
        this.state === InvoiceStateEnum.Sent ||
        this.state === InvoiceStateEnum.Approved ||
        this.state === InvoiceStateEnum.Draft
      );
    }
  },
  data() {
    return {
      InvoiceStateEnum
    };
  }
});
